<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { chaveGlossario, ehTermo } from 'dashboard/helper/captainGlossario';

// O "?" ao lado do nome do campo. Abre, em tooltip, o que o termo é e por quê,
// com um exemplo. Texto vem do glossário único (captainGlossario), nunca inline.
const props = defineProps({
  termo: { type: String, required: true, validator: ehTermo },
});

const { t } = useI18n();

const texto = computed(() => {
  const explicacao = t(chaveGlossario(props.termo, 'TEXTO'));
  const exemplo = t(chaveGlossario(props.termo, 'EXEMPLO'));
  return `${explicacao}\n\n${exemplo}`;
});
const titulo = computed(() => t(chaveGlossario(props.termo, 'TITULO')));
</script>

<template>
  <button
    v-tooltip.bottom="{
      content: texto,
      html: false,
      popperClass: 'dica-do-campo',
    }"
    type="button"
    :aria-label="titulo"
    :data-testid="`dica-${termo.toLowerCase()}`"
    class="inline-flex size-4 shrink-0 items-center justify-center rounded-full border border-n-slate-8 text-[10px] font-bold text-n-slate-11 hover:border-n-slate-11 hover:text-n-slate-12"
  >
    ?
  </button>
</template>

<style>
/* Tooltip do glossário: caixa legível, não uma faixa de ponta a ponta. */
.dica-do-campo .v-popper__inner {
  max-width: 320px;
  white-space: pre-line;
  text-align: left;
}
</style>
